import React from 'react';
import { getInitials } from '../../utils/helpers';

interface InitialsAvatarProps {
  firstName?: string;
  lastName?: string;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

const InitialsAvatar: React.FC<InitialsAvatarProps> = ({ 
  firstName = '', 
  lastName = '', 
  size = 50, 
  className = '',
  style = {}
}) => {


  // Function to generate a consistent color based on name
  const getColorFromName = (name: string): string => {
    const colors = [
      '#05ACD9', 
    ];
    
    let hash = 0;
    const fullName = name && name?.toLowerCase().trim()|| "U";
    
    if (fullName.length === 0) return colors[0];
    
    for (let i = 0; i < fullName.length; i++) {
      hash = fullName.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    return colors[Math.abs(hash) % colors.length];
  };

  const initials = getInitials(firstName, lastName);
  const backgroundColor = getColorFromName(firstName + lastName);
  const fontSize = size * 0.4;

  return (
    <div
      className={`rounded-full flex items-center justify-center text-white font-bold shadow-lg ${className}`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        color: '#05ACD9',
        backgroundColor: 'white',
        fontSize: `${fontSize}px`,
        fontFamily: 'system-ui, -apple-system, sans-serif',
        letterSpacing: '1px',
        ...style
      }}
    >
      {initials || '?'}
    </div>
  );
};

export default InitialsAvatar;